var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "url(#pattern0_596_449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_596_449",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_596_449",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_596_449",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAThJREFUWIXtlkFKw2AQhd9UN4JXUO9gxYil6NaTFK+gO6kuvIBLBY+hVNCFqFsvYOoNrLhRPjd/ZEhoktYk3eSDwMyQmfeSwPyRWhaM+QTYkbRWs2ZsZk+ZKnBIcwwS3Y7zsF3zk3v+tLyBC0lxA+JvQaulRVJ1e+BT0p2ZfaXm7UrCzB4LJ1SwB25y5g2m6Va5B6JUvufi/TIG/rMHJpKGObOXpjUuJ4GZPUvamNPA3HSKb2kNtAYaMgBEQDzD4vkGboGV0N8F3sOMXloI6AHjcG1mnACXc27Ag9B/7WofwMjlo1BLuMq8AUnZ/7RiJpJeQ3zv6quS+i7vh1rCQxKkD6NI0npJ8R9JL2Y2dv2nko4K+s7M7LikxuwAJzmf67w24RImmhF3JoZOPH1QNWZiC+guRLylLL+LDPJgdUC89gAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.6569d9f62240742d5e8393adf54b3b5a.svg";
export { ForwardRef as ReactComponent };